import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtogokarnatourpackages() {



    const cardData = {




keyword: "Belgaum to Gokarna Tour Packages",

headingDescription: "Belgaum Taxi Service offers comfortable and customizable Belgaum to Gokarna tour packages for families, couples, friends, corporate groups, and travelers looking for a relaxing coastal holiday experience. Our Belgaum to Gokarna tour packages are designed to provide convenient private cab travel with flexible sightseeing options, comfortable vehicles, and experienced drivers. Whether you are planning a weekend beach trip, temple visit, family vacation, honeymoon journey, or a multi-day Karnataka coastal tour, we provide customized travel solutions according to your requirements. Choose from Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars based on your group size and travel needs. Our packages include doorstep pickup from Belgaum, comfortable highway travel, sightseeing assistance, flexible stop options, return journey arrangements, transparent pricing, easy booking, and 24/7 customer support. Belgaum Taxi Service helps travelers explore Gokarna's famous beaches, temples, waterfalls, viewpoints, and nearby coastal attractions without the inconvenience of public transportation. With professional chauffeurs, clean vehicles, safe driving, and customer-focused service, we ensure a memorable and enjoyable journey from Belgaum to Gokarna. Whether you are traveling for relaxation, pilgrimage, photography, adventure, or family bonding, our Gokarna tour packages provide a complete travel experience with comfort and convenience.",

topPlaces: [
  {
    title: "Gokarna Mahabaleshwar Temple",
    description: "Gokarna Mahabaleshwar Temple is one of Karnataka's most important pilgrimage destinations dedicated to Lord Shiva. The ancient temple attracts thousands of devotees and is known for its spiritual importance, traditional architecture, and religious significance."
  },
  {
    title: "Om Beach",
    description: "Om Beach is Gokarna's most famous beach, named after its unique Om-shaped shoreline. It is known for scenic sea views, water activities, peaceful surroundings, beach cafes, and beautiful sunsets, making it a favorite destination for tourists and couples."
  },
  {
    title: "Kudle Beach",
    description: "Kudle Beach is a peaceful coastal attraction in Gokarna famous for its long sandy shoreline, relaxed atmosphere, sunset views, and beachside experiences. It is an ideal place for travelers looking to enjoy nature and relaxation."
  },
  {
    title: "Half Moon Beach",
    description: "Half Moon Beach is a beautiful hidden beach near Gokarna known for its clear waters, natural beauty, and calm environment. It is popular among adventure lovers and travelers seeking a less crowded beach experience."
  },
  {
    title: "Paradise Beach",
    description: "Paradise Beach is a scenic coastal destination accessible through trekking routes or boat rides. It offers a peaceful atmosphere, clean surroundings, and beautiful views of the Arabian Sea."
  },
  {
    title: "Yana Caves",
    description: "Yana Caves is a unique natural attraction near Gokarna known for massive black limestone rock formations, forest surroundings, and trekking opportunities. It is a popular destination for nature lovers and adventure travelers."
  },
  {
    title: "Murudeshwar",
    description: "Murudeshwar is a famous coastal pilgrimage destination known for the massive Shiva statue, Murudeshwar Temple, beaches, and Arabian Sea views. Many travelers combine Gokarna and Murudeshwar in a single coastal Karnataka tour."
  },
  {
    title: "Jog Falls",
    description: "Jog Falls is one of India's highest waterfalls and a major natural attraction in Karnataka. The spectacular waterfall views, surrounding greenery, and scenic landscapes make it a popular sightseeing destination."
  },
  {
    title: "Dandeli",
    description: "Dandeli is a famous adventure destination known for wildlife sanctuary, river rafting, jungle safari, forests, and outdoor activities. It is a great addition for travelers planning an extended Karnataka holiday."
  },
  {
    title: "Goa",
    description: "Goa is a world-famous coastal destination known for beaches, resorts, churches, nightlife, water sports, and sightseeing attractions. Travelers often combine Gokarna and Goa for an exciting coastal road trip experience."
  }
],




"services": [
  {
    "name": "Belgaum to Gokarna Tour Packages",
    "description": "Book Belgaum to Gokarna Tour Packages for a comfortable and memorable coastal journey with professional chauffeurs and well-maintained vehicles. Enjoy customized sightseeing plans covering Gokarna beaches, temples, and tourist attractions with Sedan, Ertiga, Innova Crysta, and premium cab options."
  },
  {
    "name": "Belgaum to Gokarna Cab",
    "description": "Hire Belgaum to Gokarna Cab for safe, comfortable, and reliable outstation travel with experienced drivers and clean AC vehicles. Get convenient transportation options for beach trips, family vacations, sightseeing, and personal journeys."
  },
  {
    "name": "Belgaum to Gokarna Taxi",
    "description": "Choose Belgaum to Gokarna Taxi for hassle-free travel with professional chauffeurs, affordable fares, and multiple vehicle choices. Enjoy a smooth journey from Belgaum to Gokarna with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Gokarna Cab Service",
    "description": "Book Belgaum to Gokarna Cab Service for reliable transportation with doorstep pickup, skilled drivers, and comfortable vehicles. Our taxi services are ideal for family tours, beach vacations, sightseeing trips, and long-distance travel."
  },
  {
    "name": "Belgaum to Gokarna Taxi Service",
    "description": "Get Belgaum to Gokarna Taxi Service with clean AC cars, professional drivers, transparent pricing, and flexible travel solutions. Enjoy safe and convenient transportation for personal trips, family journeys, and holiday packages."
  },
  {
    "name": "Belgaum to Gokarna One Way Cab",
    "description": "Book Belgaum to Gokarna One Way Cab for affordable single-trip travel without return charges. Enjoy comfortable seating, fixed pricing, experienced chauffeurs, and convenient pickup services."
  },
  {
    "name": "Belgaum to Gokarna One Way Taxi",
    "description": "Choose Belgaum to Gokarna One Way Taxi for economical and reliable transportation with professional drivers. Perfect for travelers looking for budget-friendly one direction travel between Belgaum and Gokarna."
  },
  {
    "name": "Belgaum to Gokarna Cab Booking",
    "description": "Complete Belgaum to Gokarna Cab Booking online with easy reservations, quick confirmation, and multiple vehicle options. Select Sedan, Ertiga, Innova Crysta, or SUV cabs according to your travel requirements."
  },
  {
    "name": "Belgaum to Gokarna Taxi Booking",
    "description": "Reserve Belgaum to Gokarna Taxi Booking services for comfortable and convenient travel with experienced chauffeurs. Get reliable taxi options for family trips, sightseeing, and outstation journeys."
  },
  {
    "name": "Belgaum to Gokarna Car Rental",
    "description": "Choose Belgaum to Gokarna Car Rental for private chauffeur-driven vehicles with comfortable seating and professional service. Ideal for beach holidays, family tours, business travel, and sightseeing trips."
  },
  {
    "name": "Belgaum to Gokarna Outstation Cab",
    "description": "Hire Belgaum to Gokarna Outstation Cab for safe and comfortable long-distance travel. Enjoy clean AC vehicles, experienced drivers, transparent fares, and flexible one way or round trip packages."
  },
  {
    "name": "Belgaum to Gokarna Innova Crysta Cab",
    "description": "Book Belgaum to Gokarna Innova Crysta Cab for premium and spacious travel with luxury seating, large luggage capacity, and professional chauffeurs. Perfect for families, groups, and comfortable beach vacations."
  },
  {
    "name": "Belgaum to Gokarna Ertiga Cab",
    "description": "Choose Belgaum to Gokarna Ertiga Cab for affordable 6 to 7 seater travel with spacious interiors and comfortable seating. Ideal for family trips, group tours, and holiday transportation."
  },
  {
    "name": "Belgaum to Gokarna Sedan Cab",
    "description": "Book Belgaum to Gokarna Sedan Cab for economical and comfortable travel with clean AC cars and professional drivers. Suitable for couples, small families, business trips, and smooth highway journeys."
  },
  {
    "name": "Belgaum to Gokarna Round Trip Cab",
    "description": "Hire Belgaum to Gokarna Round Trip Cab for convenient return journeys with affordable packages and flexible schedules. Perfect for beach sightseeing, family vacations, temple visits, and weekend getaways."
  },
  {
    "name": "Belgaum to Gokarna Private Taxi",
    "description": "Reserve Belgaum to Gokarna Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and hassle-free transportation throughout your coastal journey."
  },
  {
    "name": "Cheap Belgaum to Gokarna Cab",
    "description": "Find Cheap Belgaum to Gokarna Cab services offering affordable fares with quality vehicles and reliable drivers. Travel comfortably with budget-friendly transportation without compromising safety and convenience."
  },
  {
    "name": "Best Belgaum to Gokarna Tour Package",
    "description": "Choose the Best Belgaum to Gokarna Tour Package with customized itineraries, comfortable vehicles, and professional drivers. Explore Gokarna beaches, temples, and tourist attractions with a convenient cab package."
  },
  {
    "name": "Online Belgaum to Gokarna Cab Booking",
    "description": "Complete Online Belgaum to Gokarna Cab Booking with simple reservations, instant confirmation, and flexible travel options. Get doorstep pickup and comfortable vehicles for a smooth journey."
  },
  {
    "name": "Belgaum to Gokarna Taxi Fare",
    "description": "Check Belgaum to Gokarna Taxi Fare for affordable and transparent pricing with no hidden charges. Get comfortable cabs with professional drivers for safe and economical travel."
  },
  {
    "name": "Belgaum to Gokarna Car Hire",
    "description": "Hire Belgaum to Gokarna Car Hire services for private travel with chauffeur-driven vehicles. Choose from multiple car categories suitable for family trips, sightseeing, and holiday transportation."
  },
  {
    "name": "Belgaum to Gokarna Cab Price",
    "description": "Get affordable Belgaum to Gokarna Cab Price with flexible packages for one way and round trips. Enjoy reliable service, comfortable vehicles, and experienced chauffeurs at competitive rates."
  },
  {
    "name": "Belgaum to Gokarna Beach Tour",
    "description": "Book Belgaum to Gokarna Beach Tour for a relaxing coastal experience with comfortable cab services and professional drivers. Visit popular beaches and attractions with customized sightseeing options."
  },
  {
    "name": "Belgaum to Gokarna Family Tour",
    "description": "Plan Belgaum to Gokarna Family Tour with spacious vehicles, safe travel, and experienced chauffeurs. Enjoy a comfortable family vacation covering beaches, temples, and sightseeing destinations."
  },
  {
    "name": "Belgaum to Gokarna Cab Fare",
    "description": "Get the best Belgaum to Gokarna Cab Fare with affordable travel packages and transparent pricing. Travel comfortably with Sedan, Ertiga, Innova Crysta, and premium cab options."
  },
  {
    "name": "Belgaum to Gokarna Taxi Near Me",
    "description": "Find Belgaum to Gokarna Taxi Near Me for quick and reliable cab availability with professional drivers. Enjoy easy booking, doorstep pickup, and comfortable travel anytime."
  },
  {
    "name": "Belgaum to Gokarna Outstation Taxi",
    "description": "Book Belgaum to Gokarna Outstation Taxi for safe and convenient long-distance travel. Get clean AC vehicles, skilled chauffeurs, and flexible travel plans for personal and holiday journeys."
  },
  {
    "name": "Belgaum to Gokarna Travel Package",
    "description": "Experience Belgaum to Gokarna Travel Package with comfortable transportation, customized sightseeing plans, and professional drivers. Enjoy a smooth journey with convenient pickup and complete travel solutions."
  }
],
"tableData": [
  ["Belgaum to Gokarna Tour Packages", "Belgaum to Gokarna Cab"],
  ["Belgaum to Gokarna Taxi", "Belgaum to Gokarna Cab Service"],
  ["Belgaum to Gokarna Taxi Service", "Belgaum to Gokarna One Way Cab"],
  ["Belgaum to Gokarna One Way Taxi", "Belgaum to Gokarna Cab Booking"],
  ["Belgaum to Gokarna Taxi Booking", "Belgaum to Gokarna Car Rental"],
  ["Belgaum to Gokarna Outstation Cab", "Belgaum to Gokarna Innova Crysta Cab"],
  ["Belgaum to Gokarna Ertiga Cab", "Belgaum to Gokarna Sedan Cab"],
  ["Belgaum to Gokarna Round Trip Cab", "Belgaum to Gokarna Private Taxi"],
  ["Cheap Belgaum to Gokarna Cab", "Best Belgaum to Gokarna Tour Package"],
  ["Online Belgaum to Gokarna Cab Booking", "Belgaum to Gokarna Taxi Fare"],
  ["Belgaum to Gokarna Car Hire", "Belgaum to Gokarna Cab Price"],
  ["Belgaum to Gokarna Beach Tour", "Belgaum to Gokarna Family Tour"],
  ["Belgaum to Gokarna Cab Fare", "Belgaum to Gokarna Taxi Near Me"],
  ["Belgaum to Gokarna Outstation Taxi", "Belgaum to Gokarna Travel Package"]
],





whychoose: [
  {
    WhyChooseheading: "Amazing Belgaum to Gokarna Tour Packages",
    WhyChoosedescription: "Explore the beautiful beaches and spiritual attractions of Gokarna with a comfortable tour package from Belgaum including private cab travel, flexible schedules, and convenient trip planning."
  },
  {
    WhyChooseheading: "Perfect Beach & Temple Getaway",
    WhyChoosedescription: "Enjoy a refreshing holiday covering Gokarna beaches, temples, and nearby attractions with a well-planned travel experience suitable for families, couples, and groups."
  },
  {
    WhyChooseheading: "Private Cab for Complete Privacy",
    WhyChoosedescription: "Travel in your own dedicated vehicle from Belgaum to Gokarna without sharing rides, giving you freedom to manage stops, timings, and sightseeing plans."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Every Group",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to passenger count, luggage, and preferred comfort level."
  },
  {
    WhyChooseheading: "Customizable Gokarna Sightseeing Plans",
    WhyChoosedescription: "Create your own itinerary with popular beaches, temples, viewpoints, and nearby attractions based on your travel duration and interests."
  },
  {
    WhyChooseheading: "Ideal for Weekend Holidays",
    WhyChoosedescription: "Belgaum to Gokarna tour packages are suitable for weekend trips, family vacations, couple getaways, and group tours looking for a relaxing coastal escape."
  },
  {
    WhyChooseheading: "Experienced Drivers for Coastal Routes",
    WhyChoosedescription: "Professional chauffeurs ensure a safe and comfortable journey with proper route knowledge and support throughout your Gokarna tour."
  },
  {
    WhyChooseheading: "Flexible One Day & Multi Day Packages",
    WhyChoosedescription: "Select a one-day trip or plan a multi-day holiday package according to your sightseeing requirements and travel schedule."
  }
]

};

const faqData = [
  {
    question: "What is included in a Belgaum to Gokarna Tour Package?",
    answer: "The tour package includes private cab transportation from Belgaum to Gokarna with flexible travel options. Sightseeing and additional services depend on the selected package."
  },
  {
    question: "Can I customize my Gokarna sightseeing itinerary?",
    answer: "Yes, you can customize your itinerary by selecting preferred beaches, temples, and sightseeing locations during your trip planning."
  },
  {
    question: "Which vehicles are available for Gokarna tour packages?",
    answer: "Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV vehicles are available based on group size and comfort requirements."
  },
  {
    question: "Is this tour package suitable for families?",
    answer: "Yes, private cab packages are comfortable for families, senior citizens, couples, and groups travelling to Gokarna."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Gokarna?",
    answer: "Yes, one-way taxi services are available for travellers who only need transportation to Gokarna."
  },
  {
    question: "Can I include beach sightseeing in the package?",
    answer: "Yes, beach sightseeing and additional stops can be added according to your selected itinerary and travel duration."
  },
  {
    question: "Can I book a return cab from Gokarna to Belgaum?",
    answer: "Yes, return trip cab options are available with flexible schedules according to your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, homes, and other preferred locations."
  },
  {
    question: "Are toll and parking charges included in the tour package?",
    answer: "Toll, parking, entry fees, and other additional expenses depend on the selected package and are explained during booking."
  },
  {
    question: "How can I book a Belgaum to Gokarna Tour Package?",
    answer: "Share your travel date, number of passengers, preferred vehicle, trip duration, and sightseeing requirements to receive a suitable package quotation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Deshmukh",
    feedback: "Our Belgaum to Gokarna tour was perfectly planned. The cab was comfortable, and we enjoyed the beach sightseeing without any travel issues.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Snehal Patil",
    feedback: "We booked a family tour package and had a wonderful experience. The driver was helpful, the vehicle was spacious, and the journey was enjoyable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Gokarna Tour Packages",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-gokarna-tour-packages.webp",
  "description":
    "Book Belgaum to Gokarna Tour Packages with Belgaum Taxi Service for safe, comfortable, and affordable outstation travel. We provide one-way and round-trip cabs from Belgaum to Gokarna with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for beach holidays, temple visits, family vacations, sightseeing tours, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-gokarna-tour-packages"
  }
};





    return (
        <div>

<Helmet>
  <title>Belgaum to Gokarna Tour Packages | Beach Holiday Cabs | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Gokarna Tour Packages with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Travel in Sedan, Ertiga, SUV, Innova, and Innova Crysta with affordable Gokarna tour packages, sightseeing cabs, and beach vacation taxis available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Gokarna Tour Packages, Belgaum to Gokarna Cab, Belgaum to Gokarna Taxi, Belgaum to Gokarna Cab Service, Belgaum to Gokarna Taxi Service, Belgaum to Gokarna One Way Cab, Belgaum to Gokarna One Way Taxi, Belgaum to Gokarna Cab Booking, Belgaum to Gokarna Taxi Booking, Belgaum to Gokarna Car Rental, Belgaum to Gokarna Tour Package, Belgaum to Gokarna Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtogokarnatourpackages ;